import { Mode, PartialMenu } from "../../../../../interfaces/meMenuInterfaces/interfaces";
import { Option } from "../../../../../interfaces/interfaces";
import { MenuInitialValues } from "./AddEditMenuModal";
import { TFunction } from "i18next";
import { buildCloneInitialDisplayName, cloneNameToDisplay } from "../../../utils/cloneNameUtils";
import { MenuStatusType } from "@me-team/host/main/graphql/types";
import { toMenuStatusEnum, toMenuTypeEnum } from "../../menuEnumMappings";

export const mapToInitials = (
    mode: Mode,
    menu: PartialMenu | null | undefined,
    options: Option[],
    t: TFunction,
    opts?: {
        defaultStatusForCreate?: MenuStatusType | null;
        ensurePrimaryLanguageId?: number | null;
    }
): MenuInitialValues => {
    const { defaultStatusForCreate = null, ensurePrimaryLanguageId } = opts ?? {};

    if (mode === "create") {
        const allLangIds = options.map((o) => o.value);
        const withPrimary =
            ensurePrimaryLanguageId && !allLangIds.includes(ensurePrimaryLanguageId)
                ? [ensurePrimaryLanguageId, ...allLangIds]
                : allLangIds;

        return {
            name: "",
            type: null,
            languages: withPrimary,
            status: defaultStatusForCreate,
        };
    }

    if (!menu) {
        return { name: "", type: null, languages: [], status: null };
    }

    const langIds = (menu.languages ?? []).map((l) => l.id);
    const apiName = menu.name ?? "";

    const baseNameForDisplay = cloneNameToDisplay(apiName, t);

    const base: MenuInitialValues = {
        name: baseNameForDisplay,
        type: toMenuTypeEnum(menu.type?.slug),
        languages: langIds,
        status: toMenuStatusEnum(menu.status?.slug),
    };

    if (mode === "clone") {
        return {
            ...base,
            name: buildCloneInitialDisplayName(apiName, t),
            type: null,
            status: defaultStatusForCreate,
        };
    }

    return base;
};
